export const LinkStyle = {
    basic:
        'font-secondary text-white hover:text-white hover:no-underline py-2',
}

export const SetFlex = {
    flex: 'flex',
}
